// LIVEMOA · TikTok Review T-R1A · /terms + /privacy 페이지 상단 브랜드 헤더.
// TikTok Developer Portal 에 등록된 LIVEMOA App icon (livemoa-app-icon.png, 512×512, 검은 배경
// + LM 심볼 + LIVEMOA wordmark + 라이브모아) 원본을 그대로 사용. 신규/임의 로고 생성 없음.
import React from 'react';
import { Link } from 'react-router-dom';

export default function LivemoaLegalHeader({ current }) {
  return (
    <header
      className="w-full border-b border-black/10 dark:border-white/10 bg-white dark:bg-[#0A0A0A]"
      data-testid="legal-header"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center gap-3">
        <Link to="/" aria-label="LIVEMOA 홈으로" className="flex items-center gap-2.5" data-testid="legal-logo-link">
          {/* TikTok Developer Portal 등록 App icon 원본 그대로 · 크기만 반응형으로 조정 */}
          <img
            src="/livemoa-app-icon.png"
            alt="LIVEMOA"
            width="40"
            height="40"
            className="w-10 h-10 sm:w-11 sm:h-11 rounded-[10px] object-contain flex-shrink-0"
            data-testid="legal-app-icon"
          />
          <span
            className="font-black tracking-tight text-black dark:text-white"
            style={{ fontSize: 18, letterSpacing: -0.5 }}
            data-testid="legal-logo-wordmark"
          >
            LIVEMOA
          </span>
        </Link>
        <nav className="ml-auto flex items-center gap-3 text-[11px] sm:text-xs font-semibold text-gray-500 dark:text-gray-400">
          <Link
            to="/terms"
            className={current === 'terms' ? 'text-black dark:text-white' : 'hover:text-black dark:hover:text-white'}
            data-testid="legal-nav-terms"
          >
            이용약관
          </Link>
          <span aria-hidden="true">·</span>
          <Link
            to="/privacy"
            className={current === 'privacy' ? 'text-black dark:text-white' : 'hover:text-black dark:hover:text-white'}
            data-testid="legal-nav-privacy"
          >
            개인정보처리방침
          </Link>
        </nav>
      </div>
    </header>
  );
}
